export const AVAILABLE_CONTACT_TYPES = [
	{
		prettyName: "E-mail",
		placeholder: "exemplo@email.com.br",
		type: "EMAIL",
		id: 1
	},
	{
		prettyName: "Telefone",
		placeholder: "(21) 99999-9999",
		type: "PHONE",
		id: 2
	},
	{
		prettyName: "Celular",
		placeholder: "(21) 99999-9999",
		type: "CELLPHONE",
		id: 3
	},
	{
		prettyName: "LinkedIn",
		placeholder: "https://www.linkedin.com/in/username",
		type: "LINKEDIN",
		id: 4
	},
	{
		prettyName: "GitHub",
		placeholder: "https://github.com/username",
		type: "GITHUB",
		id: 5
	},
	{
		prettyName: "Twitter",
		placeholder: "https://twitter.com/username",
		type: "TWITTER",
		id: 6
	},
	{
		prettyName: "Facebook",
		placeholder: "https://www.facebook.com/username",
		type: "FACEBOOK",
		id: 7
	},
	{
		prettyName: "Instagram",
		placeholder: "https://www.instagram.com/username",
		type: "INSTAGRAM",
		id: 8
	},
	{
		prettyName: "YouTube",
		placeholder: "https://www.tiktok.com/@username",
		type: "TIKTOK",
		id: 9
	},
	{
		prettyName: "Snapchat",
		placeholder: "https://www.snapchat.com/add/username",
		type: "SNAPCHAT",
		id: 10
	},
	{
		prettyName: "WhatsApp",
		placeholder: "(21) 99999-9999",
		type: "WHATSAPP",
		id: 11
	},
	{
		prettyName: "Telegram",
		placeholder: "https://t.me/username",
		type: "TELEGRAM",
		id: 12
	},
	{
		prettyName: "Discord",
		placeholder: "nome_de_usuario#1234",
		type: "DISCORD",
		id: 13
	},
	{
		prettyName: "Outro",
		placeholder: "Contato",
		type: "OTHER",
		id: 0
	},
];
